import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]

import { ref } from "vue";
import { DbSelect } from "@db-ui/v-elements-enterprise/dist/components";

export default /*@__PURE__*/_defineComponent({
  __name: 'DbSelect',
  props: {
  value: {
    default: "",
  },
  disabled: {
    default: false,
  },
  errorMessage: {
    type: String,
    default: undefined,
    required: false,
  },
  name: {
    default: "",
    required: true,
  },
  label: {
    default: "",
    required: true,
  },
  ariainvalid: {
    type: Boolean,
    default: false,
    required: false,
  },
  variant: {
    type: String as () => "outline" | "semitransparent" | "solid" | "white",
    default: "semitransparent",
    required: false,
  },
},
  setup(__props) {

const choice = ref("");
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`flex flex-col ${props.errorMessage ? 'invalidArea' : ''}`)
  }, [
    _createVNode(_unref(DbSelect), {
      label: __props.label,
      name: __props.name,
      disabled: __props.disabled,
      value: __props.value,
      variant: "semitransparent",
      onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      ref_key: "choice",
      ref: choice,
      ariainvalid: false
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["label", "name", "disabled", "value"]),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createElementVNode("p", {
            class: "showError",
            innerHTML: __props.errorMessage
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})